import type { LuggageType } from "@daytrip/legacy-enums";
import { ChildSeatType, PassengerType } from "@daytrip/legacy-enums";
import { Exclude, Expose, Transform, Type } from "class-transformer";
import { IsArray, IsDefined, IsNumber } from "class-validator";

@Exclude()
export class AnonymizedPassenger {
    @IsNumber()
    @IsDefined()
    @Expose()
    public type: PassengerType;

    @IsNumber()
    @Expose()
    @Transform((value) => (value === undefined ? undefined : Number(value)))
    public childSeatType?: ChildSeatType;

    @IsArray()
    @IsDefined()
    @Expose()
    @Type(() => Number)
    public luggage: Array<LuggageType> = new Array<LuggageType>();

    @Expose()
    public assignationId?: string;

    public isAdult(): this is AdultPassenger {
        return this.type === PassengerType.Adult;
    }

    public isChild(): this is ChildPassenger {
        return this.type === PassengerType.Child;
    }

    public isLead(): this is AlienPassenger {
        return this.type === PassengerType.Lead;
    }
}

interface AdultPassenger {
    email: string;
    phoneNumber: string;
    countryId: string;
}

interface ChildPassenger {
    childSeatType: ChildSeatType;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface AlienPassenger {}
